<div *ngIf="formErrors && cnfJson.showFormErrors" class="alert alert-danger">
  {{ formErrors | json }}
</div>

<div *ngIf="atividade" class="ibox-content-container" [class.black]="enTheme === 'black'">
  <!-- Salvar -->
  <button *ngIf="hasSave" mat-raised-button type="submit" class="action-btn" (submit)="clicked()" color="primary" [disabled]="isLoading || disable">
    <mat-icon>done</mat-icon>
    {{ textSave }}
  </button>

  <!-- Duplicar -->
  <button *ngIf="hasDuplicate" mat-raised-button type="button" class="action-btn" (click)="onDuplicate($event)" color="accent" [disabled]="isLoading">
    <mat-icon>file_copy</mat-icon>
    {{ textDuplicate }}
  </button>

  <!-- Confirmar -->
  <button *ngIf="hasConfirm" mat-raised-button type="button" class="action-btn" (click)="onConfirm($event, saveInList)" color="primary" [disabled]="isLoading">
    <mat-icon>check_circle</mat-icon>
    {{ textConfirm }}
  </button>

  <!-- Salvar e Novo -->
  <button *ngIf="hasSaveAndNew" mat-raised-button type="button" class="action-btn" (click)="onSaveAndNew($event)" color="primary" [disabled]="isLoading">
    <mat-icon>done_outline</mat-icon>
    {{ textSaveAndNew }}
  </button>

  <button *ngIf="hasConfirm && isEdit && _atividade.AtividadeNo == 24666" mat-raised-button type="button" class="action-btn bnt-delete" (click)="onDelete($event)">
    <mat-icon>delete</mat-icon>
    Apagar
  </button>
</div>
